import React from "react";
import { useCardSceneLayout } from "./cardSceneLayout";

interface DecorativeSceneIconProps {
  children: React.ReactNode;
  className?: string;
  hide?: boolean;
}

export function DecorativeSceneIcon({ children, className, hide }: DecorativeSceneIconProps) {
  const layout = useCardSceneLayout();
  if (hide ?? layout.hideDecorativeIcon) {
    return null;
  }
  return (
    <div data-testid="decorative-scene-icon" className={className}>
      {children}
    </div>
  );
}
